<template>
  <vx-card title="Pie Chart">
    <!-- {{application}} -->
    <template>
      <e-charts autoresize :options="pie" ref="pie" auto-resize />
    </template>
  </vx-card>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "../components/statistics-cards/StatisticsCardLine";
import analyticsData from "./ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "../components/ChangeTimeDurationDropdown.vue";
// for pie chart
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";
import { mapGetters } from "vuex";

export default {
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    ECharts
  },
  props: ["application"],
  data() {
    return {
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      //revenueComparisonLine: {},
      goalOverview: {},

      browserStatistics: [],
      clientRetentionBar: {},

      sessionsData: {},
      chatLog: [],
      chatMsgInput: "",
      customersData: {},

      analyticsData,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [
            "New Application",
            "In-Process Application",
            "Halt Application",
            "Accepted Application",
            "Rejected Application",
            "Reviewed Application"
          ]
        },
        series: [
          {
            name: "Access source",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            color: [
              "#0079c1",
              "#ff9f43",
              "#ffc459",
              "#28c76f",
              "#ea5455",
              "#5b3cc4"
            ],
            data: [
              { id: 2, value: 0, name: "New Application" },
              { id: 3, value: 0, name: "In-Process Application" },
              { id: 4, value: 0, name: "Halt Application" },
              { id: 5, value: 0, name: "Accepted Application" },
              { id: 6, value: 0, name: "Rejected Application" },
              { id: 7, value: 0, name: "Reviewed Application" }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      },
      revenueComparisonLine: {
        analyticsData: {
          thisMonth: 0,
          lastMonth: 0
        },
        series: [
          /*{
              name: 'This Month',
              data: [45000, 47000, 44800, 47500, 45500, 48000, 46500, 48600]
            },
            {
              name: 'Last Month',
              data: [46000, 48000, 45500, 46600, 44500, 46500, 45000, 47000]
            }*/
        ],
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.1
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [4, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: ["#F97794", "#b8c2cc"],
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: ["#7367F0", "#b8c2cc"],
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            categories: ["01", "05", "09", "13", "17", "21", "26", "31"],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val;
              }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },
      subscribersGained: {
        series: [
          {
            name: "Subscribers",
            data: [28, 40, 36, 52, 38, 60, 55]
          }
        ],
        chartOptions: {
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            width: 2.5
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.7,
              opacityTo: 0.5,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: "numeric",
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          yaxis: [
            {
              y: 0,
              offsetX: 0,
              offsetY: 0,
              padding: {
                left: 0,
                right: 0
              }
            }
          ],
          tooltip: {
            x: { show: false }
          }
        }
      },
      revenueGenerated: {
        series: [
          {
            name: "Revenue",
            data: [350, 275, 400, 300, 350, 300, 450]
          }
        ],
        analyticsData: {
          revenue: 97500
        }
      },
      quarterlySales: {
        series: [
          {
            name: "Sales",
            data: [10, 15, 7, 12, 3, 16]
          }
        ],
        analyticsData: {
          sales: "36%"
        }
      },
      ordersRecevied: {
        series: [
          {
            name: "Orders",
            data: [10, 15, 8, 15, 7, 12, 8]
          }
        ],
        analyticsData: {
          orders: 97500
        }
      }
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  mounted() {
    console.log("==>>", this.pie.series.data);
    this.pie.series[0].data.map(app => {
      let assignId = this.application.find(pa => pa.status === app.id);
      console.log("assignId = ", assignId);
      if (assignId) {
        app.value = assignId.application;
      }
      return app;
    });
    let dataIndex = -1;
    let pie = this.$refs.pie;
    let dataLen = pie.options.series[0].data.length;
    setInterval(() => {
      pie.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex
      });
      dataIndex = (dataIndex + 1) % dataLen;
      pie.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex
      });
      pie.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex
      });
    }, 1000);
    this.$store.dispatch("getAllUser");
  },
  created() {
    // Subscribers gained - Statistics
    // this.$http.get('/api/card/card-statistics/subscribers')
    //     .then((response) => { this.subscribersGained = response.data })
    //     .catch((error) => { console.log(error) })
    // console.log("Data=", this.subscribersGained);
    // Revenue Generated
    // this.$http.get('/api/card/card-statistics/revenue')
    //     .then((response) => { this.revenueGenerated = response.data })
    //     .catch((error) => { console.log(error) })
    // Sales
    // this.$http.get('/api/card/card-statistics/sales')
    //     .then((response) => { this.quarterlySales = response.data })
    //     .catch((error) => { console.log(error) })
    // Orders - Statistics
    // this.$http.get('/api/card/card-statistics/orders')
    //     .then((response) => { this.ordersRecevied = response.data })
    //     .catch((error) => { console.log(error) })
    // Revenue Comparison
    // this.$http.get('/api/card/card-analytics/revenue-comparison')
    //     .then((response) => { this.revenueComparisonLine = response.data })
    //     .catch((error) => { console.log(error) })
    // Goal Overview
    // this.$http.get('/api/card/card-analytics/goal-overview')
    //     .then((response) => { this.goalOverview = response.data })
    //     .catch((error) => { console.log(error) })
    // Browser Analytics
    // this.$http.get('/api/card/card-analytics/browser-analytics')
    //     .then((response) => { this.browserStatistics = response.data })
    //     .catch((error) => { console.log(error) })
    // Client Retention
    // this.$http.get('/api/card/card-analytics/client-retention')
    //     .then((response) => { this.clientRetentionBar = response.data })
    //     .catch((error) => { console.log(error) })
    // Sessions By Device
    // this.$http.get('/api/card/card-analytics/session-by-device')
    //     .then((response) => { this.sessionsData = response.data })
    //     .catch((error) => { console.log(error) })
    // Chat Log
    // this.$http.get('/api/chat/demo-1/log')
    //     .then((response) => { this.chatLog = response.data })
    //     .catch((error) => { console.log(error) })
    // Customers
    // this.$http.get('/api/card/card-analytics/customers')
    //     .then((response) => { this.customersData = response.data })
    //     .catch((error) => { console.log(error) })
  }
};
</script>

<style lang="scss">
.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
